import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { BellIcon, ChevronRightIcon, DownloadIcon } from 'lucide-react';
import { AtnaAssistant } from '../components/collectes/AtnaAssistant';
import { AddressCard } from '../components/collectes/AddressCard';
import { CollectionCalendar } from '../components/collectes/CollectionCalendar';
import { DayDetails } from '../components/collectes/DayDetails';
export function CalendrierCollectes() {
  const [month, setMonth] = useState(new Date(2026, 8, 1));
  const [selected, setSelected] = useState(new Date(2026, 8, 10));
  const handleSelect = (date: Date) => {
    setSelected(date);
    if (date.getMonth() !== month.getMonth()) setMonth(new Date(date.getFullYear(), date.getMonth(), 1));
  };
  return <main className="bg-white" data-id="element-1905" data-mp="29vh6ubcqdofs">
      <div className="mx-auto max-w-[1200px] px-5 py-12 lg:px-10 lg:py-16" data-id="element-1906" data-mp="akzcgb7njksl">
        <nav aria-label="Breadcrumb" className="flex flex-wrap items-center gap-1.5 text-sm text-slate-500" data-id="element-1907" data-mp="amsh5kypfuxy">
          <Link to="/" className="font-semibold text-ville-deep hover:text-ville-indigo" data-id="element-1908" data-mp="351vcziab2hj4">
            Home
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-1909" data-mp="30b6kbzmw3eie" />
          <Link to="/my-collections" className="font-semibold text-ville-deep hover:text-ville-indigo" data-id="element-1910" data-mp="2vcbuidqi8pos">
            My Collections
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-1911" data-mp="2rc1mywn2dr7t" />
          <span aria-current="page" data-id="element-1912" data-mp="3o1j1m140ynln">Calendar</span>
        </nav>

        <header className="mt-4 flex flex-wrap items-end justify-between gap-4" data-id="element-1913" data-mp="3nyn4ug3wy4ys">
          <div data-id="element-1914" data-mp="3j2pmy5d04qjw">
            <h1 className="text-4xl font-extrabold tracking-tight text-ville-navy lg:text-5xl" data-id="element-1915" data-mp="3j03gya5rej3s">My Collections</h1>
            <p className="mt-2 text-[17px] text-slate-600" data-id="element-1916" data-mp="3a18acwysz6zy">A calendar tailored to your address</p>
          </div>
          <div className="flex flex-wrap gap-2" data-id="element-1917" data-mp="23lp7n0phos77">
            <button type="button" className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville hover:border-ville-indigo hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-1918" data-mp="23mh4sfyqixzl">
              <BellIcon className="h-4 w-4" aria-hidden="true" data-id="element-1919" data-mp="1r1ijl4v6mhle" />
              Reminders
            </button>
            <button type="button" className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville hover:border-ville-indigo hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-1920" data-mp="1v2u8172bkws0">
              <DownloadIcon className="h-4 w-4" aria-hidden="true" data-id="element-1921" data-mp="1ccw3v21n7ntn" />
              Download the calendar
            </button>
          </div>
        </header>

        <div className="mt-8" data-id="element-1922" data-mp="yfzc8ydpa2bp">
          <AtnaAssistant data-id="element-1923" data-mp="13dhey714jlb9" />
        </div>

        <div className="mt-6" data-id="element-1924" data-mp="13cg3w2k3yytj">
          <AddressCard data-id="element-1925" data-mp="13esh62ex8l09" />
        </div>

        <div className="mt-8 grid gap-8 lg:grid-cols-[minmax(0,1fr)_minmax(0,420px)] lg:gap-10" data-id="element-1926" data-mp="jqe9csou089h">
          <CollectionCalendar month={month} selected={selected} onMonthChange={setMonth} onSelect={handleSelect} data-id="element-1927" data-mp="esw9rswpf5e5" />
          <DayDetails date={selected} data-id="element-1928" data-mp="ssnh5asptnj6" />
        </div>
      </div>
    </main>;
}